module.exports = __webpack_public_path__ + "img/kenomo.225c3615.png";